var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "0 0 39.629 30.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(-16.407 -23.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M55.914,49.925V43.607L45.284,41.7l-10.8,5.433-9.866-1.072-7.364,3.866",
    transform: "translate(-0.364 -7.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1766",
    "data-name": "Group 1766",
    transform: "translate(16.407 23.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M38.369,30.26l9.779-5.6,7.108,5.389a.486.486,0,1,0,.587-.775l-7.621-5.778-9.954,5.7L27.536,25.5,16.759,28.6a.486.486,0,0,0,.268.935l10.482-3.012Z",
    transform: "translate(-16.407 -23.494)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2001",
    "data-name": "Rectangle 2001",
    width: 2.325,
    height: 8.106,
    transform: "translate(40.971 46.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2002",
    "data-name": "Rectangle 2002",
    width: 2.324,
    height: 6.148,
    transform: "translate(45.064 48.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2003",
    "data-name": "Rectangle 2003",
    width: 2.326,
    height: 4.432,
    transform: "translate(36.876 50.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2004",
    "data-name": "Rectangle 2004",
    width: 2.325,
    height: 8.106,
    transform: "translate(28.69 46.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2005",
    "data-name": "Rectangle 2005",
    width: 2.324,
    height: 6.148,
    transform: "translate(32.783 48.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2006",
    "data-name": "Rectangle 2006",
    width: 2.326,
    height: 6.148,
    transform: "translate(24.595 48.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2007",
    "data-name": "Rectangle 2007",
    width: 2.325,
    height: 6.389,
    transform: "translate(20.502 48.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    width: 2.326,
    height: 3.859,
    transform: "translate(16.407 50.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2009",
    "data-name": "Rectangle 2009",
    width: 2.326,
    height: 8.106,
    transform: "translate(49.156 46.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010",
    "data-name": "Rectangle 2010",
    width: 2.324,
    height: 6.148,
    transform: "translate(53.25 48.329)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecast);
export default __webpack_public_path__ + "static/media/forecast.4d1edbfb912b219aa9b06ee7f9bea903.svg";
export { ForwardRef as ReactComponent };